import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  getDashboardStatsApi,
} from "../../api/adminDashboardApi";

// ======================
// Get Dashboard Stats
// ======================

export const getDashboardStats =
  createAsyncThunk(
    "adminDashboard/getDashboardStats",
    async (_, { rejectWithValue }) => {
      try {
        const response =
          await getDashboardStatsApi();

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data || {
            message:
              "Failed to fetch dashboard data",
          }
        );
      }
    }
  );

// ======================
// Initial State
// ======================

const initialState = {
  dashboardStats: null,
  loading: false,
  error: null,
};

// ======================
// Slice
// ======================

const adminDashboardSlice =
  createSlice({
    name: "adminDashboard",

    initialState,

    reducers: {
      clearDashboardError: (
        state
      ) => {
        state.error = null;
      },
    },

    extraReducers: (builder) => {
      builder

        // ======================
        // GET DASHBOARD STATS
        // ======================

        .addCase(
          getDashboardStats.pending,
          (state) => {
            state.loading = true;
            state.error = null;
          }
        )

        .addCase(
          getDashboardStats.fulfilled,
          (state, action) => {
            state.loading = false;

            state.dashboardStats =
              action.payload.dashboardStats;
          }
        )

        .addCase(
          getDashboardStats.rejected,
          (state, action) => {
            state.loading = false;

            state.error =
              action.payload?.message ||
              "Something went wrong";
          }
        );
    },
  });

export const {
  clearDashboardError,
} = adminDashboardSlice.actions;

export default adminDashboardSlice.reducer;